import { memo, useCallback, useState } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useLeftClick } from "../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { MULTILEG_DATA_OPTION_INDEX, OPTION_CHAIN, OPTION_CHAIN_GRID_INDEX } from "../../utils/global_variables";
import { toggleOptionChainCheckBox, updateLegDataForOptionChain } from "../../redux/actions/optionChain";


const TogglerAndCheckBox = ({ arrRowData, ...props }) => {
    const dispatch = useDispatch();
    const arrLegDataForOptionChain = useSelector(state => state?.optionChain?.arrLegDataForOptionChain);
    const isToggle = useSelector(state => state?.optionChain?.isToggle);

    const [showPopover, setShowPopover] = useState(false);







    /*
        Below function addes the legs that are slected while doing multileg order in option chain 
    */
    const getFullType = (type) => {
        switch (type) {
            case 'CE':
                return 'CALL';
            case 'PE':
                return 'PUT';
            default:
                return '';
        }
    };

    const addOrRemoveLegFromToaster = useCallback((type, scripType, data, indexToRemove) => {
        switch (type) {
            case 'add':
                let arrOptionChainIndexValues = Object.values(MULTILEG_DATA_OPTION_INDEX).sort((a, b) => a - b);
                let arrOptionChainIndex = new Array(arrOptionChainIndexValues[arrOptionChainIndexValues.length - 1] + 1).fill('');
                let newDAta = arrLegDataForOptionChain;
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.LEG_NUMBER] = arrLegDataForOptionChain?.length + 1;
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.SEGMENT_ID] = Number(data[OPTION_CHAIN_GRID_INDEX.CALL_SEGMENT_ID_TOKEN]?.split('_')[0]);
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.TOKEN] = scripType === 'CE' ? Number(data[OPTION_CHAIN_GRID_INDEX.CALL_SEGMENT_ID_TOKEN]?.split('_')[1]) : Number(data[OPTION_CHAIN_GRID_INDEX.PUT_SEGMENT_ID_TOKE]?.split('_')[1]);
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.SCRIP_TYPE] = scripType;
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.NEXPIRY_DATE] = data[OPTION_CHAIN_GRID_INDEX.CALL_NEXPIRY_DATE];
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.STRIKE_PRICE] = data[OPTION_CHAIN_GRID_INDEX.STRIKE_PRICE];
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.LTP] = scripType === 'CE' ? data[OPTION_CHAIN_GRID_INDEX.LTP_CALL] : data[OPTION_CHAIN_GRID_INDEX.LTP_PUT];
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.LEG_PRICE] = scripType === 'CE' ? data[OPTION_CHAIN_GRID_INDEX.LTP_CALL] : data[OPTION_CHAIN_GRID_INDEX.LTP_PUT];
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.LTP_PERCENT] = scripType === 'CE' ? data[OPTION_CHAIN_GRID_INDEX.CALL_PERCENT_CHANGE_LTP] : data[OPTION_CHAIN_GRID_INDEX.PUT_PERCENT_CHANGE_LTP];
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.CHANGE_IN_LTP] = scripType === 'CE' ? data[OPTION_CHAIN_GRID_INDEX.CALL_CHANGE_IN_LTP] : data[OPTION_CHAIN_GRID_INDEX.PUT_CHANGE_IN_LTP];
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.BUY_PRICE] = scripType === 'CE' ? data[OPTION_CHAIN_GRID_INDEX.CALL_BUY_PRICE] : data[OPTION_CHAIN_GRID_INDEX.PUT_BUY_PRICE];
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.SELL_PRICE] = scripType === 'CE' ? data[OPTION_CHAIN_GRID_INDEX.CALL_SELL_PRICE] : data[OPTION_CHAIN_GRID_INDEX.PUT_SELL_PRICE];
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.SELECTED_EXPIRY] = scripType === 'CE' ? data[OPTION_CHAIN_GRID_INDEX.LTP_CALL] : data[OPTION_CHAIN_GRID_INDEX.LTP_PUT];
                newDAta.push(arrOptionChainIndex);
                dispatch(updateLegDataForOptionChain([...newDAta]));
                break;
            case 'remove':
                let updated = [...arrLegDataForOptionChain];
                updated.splice(indexToRemove, 1);
                updated = updated.map((item, idx) => {
                    const newItem = [...item];
                    newItem[0] = idx + 1;
                    return newItem;
                });
                dispatch(updateLegDataForOptionChain([...updated]));
                break;
            default:
                break;
        }
    }, [arrLegDataForOptionChain]);
    const handleCheckBoxClick = useCallback((event) => {
        // event?.preventDefault();
        // event?.stopPropagation();
        if (props?.colDef?.type === OPTION_CHAIN?.CALL) {
            // if scrip not present add if present remove 
            let nIndex = arrLegDataForOptionChain?.findIndex(item => {
                return item[MULTILEG_DATA_OPTION_INDEX?.SEGMENT_ID] + "_" + item[MULTILEG_DATA_OPTION_INDEX?.TOKEN] + '_' + getFullType(item[MULTILEG_DATA_OPTION_INDEX?.SCRIP_TYPE]) === arrRowData[OPTION_CHAIN_GRID_INDEX.CALL_SEGMENT_ID_TOKEN];
            });
            if (nIndex === -1) {
                let data = arrRowData;
                data[OPTION_CHAIN_GRID_INDEX.CALL_MULTILEG_COLOR] = true;
                addOrRemoveLegFromToaster('add', 'CE', data);
                // update ref so it give spl background for sleeclted leg
                props?.node?.updateData(data);

            } else if (nIndex > -1) {
                let dataCopy = arrRowData;
                dataCopy[OPTION_CHAIN_GRID_INDEX.CALL_MULTILEG_COLOR] = false;
                props?.node?.updateData(dataCopy);
                // update ref so it remove spl background for sleeclted leg
                addOrRemoveLegFromToaster('remove', 'CE', dataCopy, nIndex);
            } else {
                // ussh silent do not do anything here 
            }
        } else if (props?.colDef?.type === OPTION_CHAIN?.PUT) {
            // if present delete if not add
            let aIndex = arrLegDataForOptionChain?.findIndex(item => {
                return item[MULTILEG_DATA_OPTION_INDEX?.SEGMENT_ID] + "_" + item[MULTILEG_DATA_OPTION_INDEX?.TOKEN] + '_' + getFullType(item[MULTILEG_DATA_OPTION_INDEX?.SCRIP_TYPE]) === arrRowData[OPTION_CHAIN_GRID_INDEX.PUT_SEGMENT_ID_TOKE];
            });

            if (aIndex === -1) {
                let data1 = arrRowData;
                data1[OPTION_CHAIN_GRID_INDEX.PUT_MULTILEG_COLOR] = true;
                props?.node?.updateData(data1);
                addOrRemoveLegFromToaster('add', 'PE', data1);
                // update ref so it give spl background for sleeclted leg

            } else if (aIndex > -1) {
                let data1 = arrRowData;
                data1[OPTION_CHAIN_GRID_INDEX.PUT_MULTILEG_COLOR] = false;
                props?.node?.updateData(data1);
                addOrRemoveLegFromToaster('remove', 'PE', data1, aIndex);
            } else {
                // ussh silent do not do anything here
            }
        } else {
            // ntg to do here
        }
    }, [dispatch, arrLegDataForOptionChain, props.colDef.type, props?.node, arrRowData]);






    /*
            Below function is used only when checkox is toggled an returns tru are false
            if the checkbox need to be checked by default
    */
    const isChecked = useCallback(() => { // used useCallBack insted useMemo because in case of no multileg we dont want this to run so avoided useMemo
        switch (props?.colDef?.type) {
            case OPTION_CHAIN.CALL:
                let nIndex = arrLegDataForOptionChain?.findIndex(item => {
                    return item[MULTILEG_DATA_OPTION_INDEX?.SEGMENT_ID] + "_" + item[MULTILEG_DATA_OPTION_INDEX?.TOKEN] + '_' + getFullType(item[MULTILEG_DATA_OPTION_INDEX?.SCRIP_TYPE]) === arrRowData[OPTION_CHAIN_GRID_INDEX.CALL_SEGMENT_ID_TOKEN];
                });
                if (nIndex > -1) {
                    let data = [...arrRowData];
                    if (!data[OPTION_CHAIN_GRID_INDEX.CALL_MULTILEG_COLOR]) {
                        data[OPTION_CHAIN_GRID_INDEX.CALL_MULTILEG_COLOR] = true;
                        props?.node?.updateData(data);
                    }
                    return true;

                } else {
                    let data1 = [...arrRowData];
                    if (data1[OPTION_CHAIN_GRID_INDEX.CALL_MULTILEG_COLOR]) {
                        data1[OPTION_CHAIN_GRID_INDEX.CALL_MULTILEG_COLOR] = false;
                        props?.node?.updateData(data1);
                    }
                    return false;
                }
            case OPTION_CHAIN.PUT:
                let aIndex = arrLegDataForOptionChain?.findIndex(item => {
                    return item[MULTILEG_DATA_OPTION_INDEX?.SEGMENT_ID] + "_" + item[MULTILEG_DATA_OPTION_INDEX?.TOKEN] + '_' + getFullType("PE") === arrRowData[OPTION_CHAIN_GRID_INDEX.PUT_SEGMENT_ID_TOKE];
                });
                if (aIndex > -1) {
                    let data2 = [...arrRowData];
                    if (!data2[OPTION_CHAIN_GRID_INDEX.PUT_MULTILEG_COLOR]) {
                        data2[OPTION_CHAIN_GRID_INDEX.PUT_MULTILEG_COLOR] = true;
                        props?.node?.updateData(data2);
                    }
                    return true;

                } else {
                    let data3 = [...arrRowData];
                    if (data3[OPTION_CHAIN_GRID_INDEX.PUT_MULTILEG_COLOR]) {
                        data3[OPTION_CHAIN_GRID_INDEX.PUT_MULTILEG_COLOR] = false;
                        props?.node?.updateData(data3);
                    }
                    return false;
                }
            default:
                return false;
        }

    }, [arrLegDataForOptionChain, props?.colDef?.type, arrRowData, props?.api, dispatch]);


    const leftClick = useCallback((e) => {
        if (e?.button === 0) {
            setShowPopover(false);
        }
    }, []);
    const [targetElement] = useLeftClick(leftClick);
    const onContextMenu = useCallback((e) => {
        if (e?.ctrlKey) {
            return;
        }
        if ((props?.colDef?.type === OPTION_CHAIN.CALL && arrRowData[OPTION_CHAIN_GRID_INDEX.IS_CALL_DATA_PRESENT] === "-")
            || (props?.colDef?.type === OPTION_CHAIN.PUT && arrRowData[OPTION_CHAIN_GRID_INDEX.IS_PUT_DATA_PRESENT] === "-")) return;
        setShowPopover(true);
    }, [arrRowData, props?.colDef?.type]);
    const isDisabled = useCallback(() => {
        if ((props?.colDef?.type === OPTION_CHAIN.CALL && arrRowData[OPTION_CHAIN_GRID_INDEX.IS_CALL_DATA_PRESENT] === "-")
            || (props?.colDef?.type === OPTION_CHAIN.PUT && arrRowData[OPTION_CHAIN_GRID_INDEX.IS_PUT_DATA_PRESENT] === "-")) return true;
    }, [arrRowData, props?.colDef?.type]);
    return (<>
        {!isToggle ? <div className={`${isDisabled() ? "div-disabled" : ""} `} ref={targetElement} onClick={onContextMenu} >
            <span class="icon-12 icon-kebab icon-dark flex-shrink-0"></span>
        </div> : <input type="checkbox" disabled={arrLegDataForOptionChain?.length >= 3 ? true : false} checked={isChecked()} onChange={(e) => handleCheckBoxClick(e)} />}
    </>);
};

export default memo(TogglerAndCheckBox);